import SupplyDashboard from './Supply/screens/Dashboard';
import Ticket from './Supply/screens/Ticket';
import SlipPreview from './Supply/screens/SlipPreview';

const routes = rootPath => [
  {
    path: `${rootPath}`,
    exact: true,
    component: SupplyDashboard,
  },
  {
    path: `${rootPath}/ticket/:ticketId`,
    exact: false,
    component: Ticket,
  },
  {
    path: `${rootPath}/slip/:slipId`,
    exact: false,
    component: SlipPreview,
  },
];

export default routes;
